import React, { useState } from 'react'
import Container from '../../Components/Container'
import toast, { Toaster } from 'react-hot-toast'
import { FaSearch } from 'react-icons/fa'
import { IoReload } from 'react-icons/io5'
import { FaBoxOpen, FaMoneyBillWave, FaPercentage } from 'react-icons/fa'

const readJson = async (res) => {
    if (!res.ok) throw new Error('Sunucu yanıt vermedi')
    return res.json()
}

const EMPTY_AGG_STATS = {
    sale_count: 0,
    product_count: 0,
    product_price: 0,
    product_cost: 0,
    sale_price: 0,
    sale_cost: 0,
    total_product_cost: 0,
    total_sale_cost: 0,
}

const sumKeys = ['sale_count']
const avgKeys = [
    'product_count',
    'product_price',
    'product_cost',
    'sale_price',
    'sale_cost',
    'total_product_cost',
    'total_sale_cost',
]

function calculateStats(rows) {
    if (!Array.isArray(rows) || rows.length === 0) {
        return { ...EMPTY_AGG_STATS }
    }
    const result = {}
    const count = rows.length

    sumKeys.forEach((key) => {
        result[key] = rows.reduce((acc, item) => acc + parseFloat(item[key]), 0)
    })

    avgKeys.forEach((key) => {
        const sum = rows.reduce((acc, item) => acc + parseFloat(item[key]), 0)
        result[key] = sum / count
    })

    return result
}

const num = (v) => {
    const n = parseFloat(v)
    return Number.isFinite(n) ? n : 0
}

const StatTile = ({ label, value, accent = 'slate' }) => {
    const accents = {
        slate: 'border-l-slate-400 from-slate-50/95 to-white ring-slate-100/90',
        blue: 'border-l-sky-500 from-sky-50/90 to-white ring-sky-100/70',
        emerald: 'border-l-emerald-500 from-emerald-50/90 to-white ring-emerald-100/70',
    }
    return (
        <div
            className={`rounded-2xl border-l-[3px] bg-gradient-to-br p-4 shadow-sm ring-1 transition duration-200 hover:-translate-y-px hover:shadow-md hover:shadow-slate-200/60 ${accents[accent] || accents.slate}`}
        >
            <p className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">
                {label}
            </p>
            <div className="mt-2 text-lg font-bold tabular-nums tracking-tight text-slate-900">
                {value}
            </div>
        </div>
    )
}

const TxBadge = ({ type }) => {
    const t = Number(type)
    const cfg = {
        1: { label: 'Satış', className: 'bg-emerald-50 text-emerald-800 ring-emerald-200/60' },
        0: { label: 'İade', className: 'bg-amber-50 text-amber-900 ring-amber-200/60' },
        2: { label: 'Zayiat', className: 'bg-rose-50 text-rose-800 ring-rose-200/60' },
    }
    const c = cfg[t]
    if (!c) return <span className="text-slate-400">—</span>
    return (
        <span
            className={`inline-flex items-center justify-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${c.className}`}
        >
            {c.label}
        </span>
    )
}

const TableShell = ({ title, icon, accentClass, children }) => (
    <div className="overflow-hidden rounded-3xl border border-slate-200/50 bg-white/85 shadow-xl shadow-slate-200/50 ring-1 ring-white/60 backdrop-blur-sm">
        <div
            className={`flex items-center gap-4 border-b border-slate-100/80 px-5 py-4 ${accentClass}`}
        >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-lg shadow-md shadow-slate-200/50 ring-1 ring-slate-100">
                {icon}
            </span>
            <div>
                <h3 className="text-base font-bold tracking-tight text-slate-900">{title}</h3>
                <p className="text-xs text-slate-500">Kayıtlar tarih sırasıyla listelenir</p>
            </div>
        </div>
        <div className="p-4 sm:p-5">{children}</div>
    </div>
)

const İmportHistory = () => {
    const [barcode, setBarcode] = useState(window.localStorage.getItem('selectedProduct') || '')
    const [loading, setLoading] = useState(false)
    const [product, setProduct] = useState(null)
    const [salesData, setSalesData] = useState([])
    const [purchasesData, setPurchasesData] = useState([])
    const [currentStock, setCurrentStock] = useState(0)
    const [totalAvarageSale, setTotalAvarageSale] = useState(null)

    const formatCurrency = (value) => {
        const n = num(value)
        return (
            n.toLocaleString('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }) + ' ₺'
        )
    }

    const fetchBarcode = () => {
        if (!barcode) {
            toast.error('Lütfen bir barkod giriniz')
            return
        }

        setLoading(true)
        const formdata = new FormData()
        formdata.append('action', 'selectWithBarcode')
        formdata.append('barcode', barcode || '0001')

        fetch(process.env.REACT_APP_BASE_URL + 'storeHistory.php', {
            method: 'POST',
            body: formdata,
        })
            .then(readJson)
            .then((data) => {
                setLoading(false)
                if (Number(data.status) !== 200) {
                    toast.error(data.message || 'Veri bulunamadı')
                } else {
                    setProduct(data.product)
                    setSalesData(data.totalSales || [])
                    setPurchasesData(data.purchases || [])
                    setCurrentStock(data.stock || 0)
                    setTotalAvarageSale(calculateStats(data.totalAvarageSale))
                    toast.success('Ürün bilgileri yüklendi')
                }
            })
            .catch((e) => {
                setLoading(false)
                toast.error('Bir hata oluştu')
                console.error(e)
            })
    }

    const keyHandel = (e) => {
        if (e.key === 'Enter') {
            fetchBarcode()
        }
    }

    const clearData = () => {
        setProduct(null)
        setSalesData([])
        setPurchasesData([])
        setCurrentStock(0)
        setTotalAvarageSale(null)
        setBarcode('')
    }

    const stats = totalAvarageSale ?? EMPTY_AGG_STATS
    const avgBuyUnit =
        stats.product_count > 0 ? stats.product_cost / stats.product_count : num(product?.cost)
    const totalBuySpend =
        stats.product_count > 0 && stats.product_cost > 0
            ? stats.product_count * stats.product_cost
            : num(product?.count) * num(product?.cost)
    const marginPct =
        stats.sale_price === 0
            ? '0.00'
            : (((stats.sale_price - stats.product_cost) / stats.sale_price) * 100).toFixed(2)
    const displayProductCount = stats.product_count || num(product?.count) || 0

    const tableHead =
        'sticky top-0 z-10 bg-gradient-to-b from-slate-50 to-slate-50/90 text-left text-[11px] font-bold uppercase tracking-wider text-slate-500 backdrop-blur-md'
    const th = 'px-4 py-3.5 first:pl-5 last:pr-5'
    const tr = 'border-b border-slate-100/90 transition-colors last:border-0 hover:bg-indigo-50/40'
    const td = 'px-4 py-3.5 text-sm text-slate-700 first:pl-5 last:pr-5'

    return (
        <Container padding bg="#eef2ff">
            <Toaster position="top-right" toastOptions={{ className: 'text-sm shadow-lg' }} />
            <div className="relative mx-auto w-full max-w-7xl space-y-8 px-0 sm:px-0">
                <div
                    className="pointer-events-none absolute -left-24 -top-10 h-80 w-80 rounded-full bg-violet-400/25 blur-3xl"
                    aria-hidden
                />
                <div
                    className="pointer-events-none absolute -right-16 top-32 h-72 w-72 rounded-full bg-cyan-400/20 blur-3xl"
                    aria-hidden
                />

                <header className="relative space-y-3">
                    <span className="inline-flex items-center rounded-full bg-white/90 px-3.5 py-1 text-[11px] font-bold uppercase tracking-widest text-indigo-700 shadow-sm ring-1 ring-indigo-100">
                        Stok hareketleri
                    </span>
                    <div>
                        <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
                            Ürün &amp; stok geçmişi
                        </h1>
                        <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-600">
                            Barkod ile saniyeler içinde satın alım, satış ve özet metrikleri tek ekranda.
                        </p>
                    </div>
                </header>

                <div className="relative overflow-hidden rounded-3xl border border-white/70 bg-white/75 p-5 shadow-xl shadow-indigo-950/5 ring-1 ring-slate-200/60 backdrop-blur-md sm:p-6">
                    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-indigo-300/50 to-transparent" />
                    <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
                        <div className="relative min-w-0 flex-1">
                            <FaSearch className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-indigo-400" />
                            <input
                                value={barcode}
                                onKeyDown={keyHandel}
                                onChange={(e) => setBarcode(e.target.value)}
                                placeholder="Barkod numarasını girin…"
                                disabled={loading}
                                className="h-12 w-full rounded-2xl border border-slate-200/80 bg-slate-50/80 pl-11 pr-4 text-sm text-slate-900 shadow-inner shadow-slate-200/20 outline-none transition placeholder:text-slate-400 focus:border-indigo-400/60 focus:bg-white focus:ring-2 focus:ring-indigo-500/25 disabled:opacity-60"
                            />
                        </div>
                        <div className="flex shrink-0 flex-wrap gap-2">
                            <button
                                type="button"
                                onClick={fetchBarcode}
                                disabled={loading}
                                className="inline-flex h-12 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 px-6 text-sm font-semibold text-white shadow-lg shadow-indigo-500/25 transition hover:from-indigo-500 hover:to-violet-500 hover:shadow-indigo-500/35 disabled:cursor-not-allowed disabled:opacity-60"
                            >
                                <FaSearch className="h-3.5 w-3.5 opacity-95" />
                                {loading ? 'Yükleniyor…' : 'Sorgula'}
                            </button>
                            {product && (
                                <button
                                    type="button"
                                    onClick={clearData}
                                    className="inline-flex h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200/90 bg-white px-5 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
                                >
                                    <IoReload className="h-4 w-4" />
                                    Sıfırla
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {product && (
                    <div className="relative flex flex-col gap-8">
                        <section className="overflow-hidden rounded-3xl border border-slate-200/50 bg-white shadow-xl shadow-slate-200/40 ring-1 ring-indigo-500/[0.08]">
                            <div className="relative border-b border-slate-100/80 bg-gradient-to-r from-indigo-100/80 via-white to-cyan-50/60 px-6 py-5">
                                <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_120%_80%_at_0%_0%,rgba(99,102,241,0.12),transparent_55%)]" />
                                <div className="relative">
                                    <h2 className="text-lg font-bold tracking-tight text-slate-900">
                                        Ürün özeti
                                    </h2>
                                    <p className="mt-0.5 text-sm text-slate-600">
                                        Güncel kart ve özet istatistikler
                                    </p>
                                </div>
                            </div>
                            <div className="p-5 md:p-8">
                                <div className="flex flex-col gap-8 lg:flex-row">
                                    <div className="w-full shrink-0 lg:w-[320px]">
                                        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-slate-100 via-white to-indigo-50/40 p-6 shadow-inner ring-1 ring-slate-200/60">
                                            <div className="flex min-h-[210px] items-center justify-center rounded-2xl bg-white/85 p-5 shadow-md shadow-slate-200/30 ring-1 ring-white">
                                                {product.image ? (
                                                    <img
                                                        src={product.image}
                                                        alt={product.name || ''}
                                                        className="max-h-52 max-w-full object-contain drop-shadow-sm"
                                                        onError={(e) => {
                                                            e.currentTarget.style.display = 'none'
                                                        }}
                                                    />
                                                ) : (
                                                    <span className="text-sm font-medium text-slate-400">
                                                        Görsel yok
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="mt-5 space-y-3 rounded-3xl border border-slate-100/90 bg-white/90 p-5 shadow-sm ring-1 ring-slate-100">
                                            <h3 className="text-base font-bold leading-snug text-slate-900">
                                                {product.name}
                                            </h3>
                                            <dl className="space-y-2.5 text-sm">
                                                <div className="flex justify-between gap-2 border-b border-slate-200/60 pb-2">
                                                    <dt className="text-slate-500">Barkod</dt>
                                                    <dd className="font-mono text-xs font-medium text-slate-800">
                                                        {product.barcode}
                                                    </dd>
                                                </div>
                                                <div className="flex justify-between gap-2 border-b border-slate-200/60 pb-2">
                                                    <dt className="text-slate-500">Liste fiyatı</dt>
                                                    <dd className="font-semibold text-slate-900">
                                                        {formatCurrency(product.price)}
                                                    </dd>
                                                </div>
                                                <div className="flex justify-between gap-2">
                                                    <dt className="text-slate-500">Stok</dt>
                                                    <dd className="font-semibold text-slate-900">
                                                        {currentStock} adet
                                                    </dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </div>

                                    <div className="min-w-0 flex-1 space-y-6">
                                        <div className="rounded-3xl border border-sky-100/80 bg-gradient-to-br from-sky-50/70 via-white to-white p-6 shadow-lg shadow-sky-100/40 ring-1 ring-sky-100/60">
                                            <h3 className="mb-5 flex items-center gap-3 text-base font-bold tracking-tight text-sky-950">
                                                <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-sky-100 text-sky-700 shadow-sm ring-1 ring-sky-200/50">
                                                    <FaBoxOpen className="h-4 w-4" />
                                                </span>
                                                Satın alım istatistikleri
                                            </h3>
                                            <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-3">
                                                <StatTile label="Toplam alınan" value={`${displayProductCount} adet`} accent="blue" />
                                                <StatTile label="Ort. alım fiyatı" value={formatCurrency(avgBuyUnit)} accent="blue" />
                                                <StatTile label="Toplam harcama" value={formatCurrency(totalBuySpend)} accent="blue" />
                                            </div>
                                        </div>

                                        <div className="rounded-3xl border border-emerald-100/80 bg-gradient-to-br from-emerald-50/70 via-white to-white p-6 shadow-lg shadow-emerald-100/40 ring-1 ring-emerald-100/60">
                                            <h3 className="mb-5 flex items-center gap-3 text-base font-bold tracking-tight text-emerald-950">
                                                <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700 shadow-sm ring-1 ring-emerald-200/50">
                                                    <FaMoneyBillWave className="h-4 w-4" />
                                                </span>
                                                Satış istatistikleri
                                            </h3>
                                            <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2 lg:grid-cols-4">
                                                <StatTile label="Toplam satılan" value={`${stats.sale_count} adet`} accent="emerald" />
                                                <StatTile
                                                    label="Ort. satış fiyatı"
                                                    value={formatCurrency(stats.sale_price)}
                                                    accent="emerald"
                                                />
                                                <StatTile
                                                    label="Toplam gelir"
                                                    value={formatCurrency(stats.sale_price * stats.sale_count)}
                                                    accent="emerald"
                                                />
                                                <StatTile
                                                    label="Kâr marjı"
                                                    value={
                                                        <span className="inline-flex items-center gap-1 text-emerald-700">
                                                            <FaPercentage className="h-3.5 w-3.5" />
                                                            {marginPct}%
                                                        </span>
                                                    }
                                                    accent="emerald"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
                            <TableShell
                                title="Satın alım geçmişi"
                                icon={<FaBoxOpen className="text-sky-600" />}
                                accentClass="bg-gradient-to-r from-sky-50/95 to-white/50"
                            >
                                {purchasesData.length > 0 ? (
                                    <div className="max-h-80 overflow-auto rounded-2xl border border-slate-100/80 bg-slate-50/30">
                                        <table className="w-full border-collapse text-sm">
                                            <thead className={tableHead}>
                                                <tr>
                                                    <th className={`${th} text-left`}>Tarih</th>
                                                    <th className={`${th} text-right`}>Adet</th>
                                                    <th className={`${th} text-right`}>Birim</th>
                                                    <th className={`${th} text-right`}>Toplam</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {purchasesData.map((item, index) => (
                                                    <tr key={index} className={tr}>
                                                        <td className={`${td} font-medium text-slate-800`}>
                                                            {item.date}
                                                        </td>
                                                        <td className={`${td} text-right tabular-nums`}>{item.count}</td>
                                                        <td className={`${td} text-right tabular-nums`}>
                                                            {formatCurrency(item.cost)}
                                                        </td>
                                                        <td
                                                            className={`${td} text-right font-semibold tabular-nums text-slate-900`}
                                                        >
                                                            {formatCurrency(num(item.cost) * num(item.count))}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p className="rounded-2xl border border-dashed border-slate-200/80 bg-slate-50/40 py-12 text-center text-sm font-medium text-slate-500">
                                        Bu ürün için satın alım kaydı yok.
                                    </p>
                                )}
                            </TableShell>

                            <TableShell
                                title="Satış geçmişi"
                                icon={<FaMoneyBillWave className="text-emerald-600" />}
                                accentClass="bg-gradient-to-r from-emerald-50/95 to-white/50"
                            >
                                {salesData.length > 0 ? (
                                    <div className="max-h-80 overflow-auto rounded-2xl border border-slate-100/80 bg-slate-50/30">
                                        <table className="w-full border-collapse text-sm">
                                            <thead className={tableHead}>
                                                <tr>
                                                    <th className={`${th} text-left`}>Tarih</th>
                                                    <th className={`${th} text-right`}>Adet</th>
                                                    <th className={`${th} text-right`}>Satış</th>
                                                    <th className={`${th} text-right`}>Maliyet</th>
                                                    <th className={`${th} text-right`}>Kâr</th>
                                                    <th className={`${th} text-right`}>İşlem</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salesData.map((item, index) => (
                                                    <tr key={index} className={tr}>
                                                        <td className={`${td} font-medium text-slate-800`}>
                                                            {item.date}
                                                        </td>
                                                        <td className={`${td} text-right tabular-nums`}>{item.count}</td>
                                                        <td className={`${td} text-right tabular-nums`}>
                                                            {formatCurrency(item.price)}
                                                        </td>
                                                        <td className={`${td} text-right tabular-nums`}>
                                                            {formatCurrency(item.cost)}
                                                        </td>
                                                        <td
                                                            className={`${td} text-right font-semibold tabular-nums text-emerald-700`}
                                                        >
                                                            {formatCurrency(
                                                                (num(item.price) - num(item.cost)) * num(item.count)
                                                            )}
                                                        </td>
                                                        <td className={`${td} text-right`}>
                                                            <TxBadge type={item.type} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p className="rounded-2xl border border-dashed border-slate-200/80 bg-slate-50/40 py-12 text-center text-sm font-medium text-slate-500">
                                        Bu ürün için satış kaydı yok.
                                    </p>
                                )}
                            </TableShell>
                        </div>
                    </div>
                )}

                {!product && !loading && (
                    <div className="relative overflow-hidden rounded-3xl border border-white/60 bg-white/70 px-8 py-16 text-center shadow-xl shadow-indigo-950/5 ring-1 ring-slate-200/50 backdrop-blur-md">
                        <div className="pointer-events-none absolute -right-20 -top-20 h-48 w-48 rounded-full bg-indigo-400/15 blur-3xl" />
                        <div className="pointer-events-none absolute -left-16 bottom-0 h-40 w-40 rounded-full bg-violet-400/15 blur-3xl" />
                        <div className="relative mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white shadow-lg shadow-indigo-500/30">
                            <FaSearch className="h-7 w-7 opacity-95" />
                        </div>
                        <h3 className="relative text-xl font-bold tracking-tight text-slate-900">
                            Barkod ile sorgulayın
                        </h3>
                        <p className="relative mx-auto mt-3 max-w-md text-sm leading-relaxed text-slate-600">
                            Satın alım geçmişi, satış hareketleri ve stok özeti anında listelenir.
                        </p>
                    </div>
                )}

                {loading && (
                    <div className="relative flex min-h-[300px] w-full flex-col items-center justify-center overflow-hidden rounded-3xl border border-slate-200/50 bg-white/80 shadow-xl shadow-slate-200/40 ring-1 ring-white/60 backdrop-blur-sm">
                        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-indigo-100 border-t-indigo-600" />
                        <span className="text-sm font-semibold text-slate-600">
                            Veriler yükleniyor…
                        </span>
                    </div>
                )}
            </div>
        </Container>
    )
}

export default İmportHistory
